/**
 * PATH: packages/quote-builder/src/grid/warmSheetGridAg.ts
 * FILE_ID: QB-GRID-WARM-AG-001
 * PURPOSE: Start the AG Grid dynamic-import chain without mounting SheetGrid.
 * WHY: Workbook open must overlap GET with AG Grid download; board paint must
 *   never pay for this — only call from explicit open/hover intent.
 * FLOW: warmSheetGridAg() → shared Promise.all of ag-grid chunks (cached).
 * RELATED: SheetGrid.tsx (lazy loader hits the same module URLs).
 */

let warmPromise: Promise<unknown> | null = null

/** Prefetch AG Grid JS/CSS. Safe to call repeatedly; shares one in-flight load. */
export function warmSheetGridAg(): Promise<unknown> {
  if (!warmPromise) {
    warmPromise = Promise.all([
      import('ag-grid-react'),
      import('ag-grid-community'),
      import('ag-grid-community/styles/ag-grid.css'),
      import('ag-grid-community/styles/ag-theme-quartz.css'),
    ])
  }
  return warmPromise
}
